var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSinglePerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5827,
    cy: 7.77803,
    r: 4.77803,
    stroke: "#1F342F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00002 19.2016C3.99873 18.8657 4.07385 18.5339 4.2197 18.2313C4.67736 17.316 5.96798 16.8308 7.03892 16.6112C7.81128 16.4463 8.59431 16.3362 9.38217 16.2816C10.8408 16.1535 12.3079 16.1535 13.7666 16.2816C14.5544 16.3369 15.3374 16.447 16.1099 16.6112C17.1808 16.8308 18.4714 17.2702 18.9291 18.2313C19.2224 18.8481 19.2224 19.5642 18.9291 20.181C18.4714 21.1421 17.1808 21.5814 16.1099 21.7919C15.3384 21.9636 14.5551 22.0768 13.7666 22.1306C12.5794 22.2313 11.3866 22.2496 10.1968 22.1855C9.92221 22.1855 9.65677 22.1855 9.38217 22.1306C8.59663 22.0775 7.81632 21.9642 7.04807 21.7919C5.96798 21.5814 4.68652 21.1421 4.2197 20.181C4.0746 19.8749 3.99955 19.5403 4.00002 19.2016Z",
    stroke: "#1F342F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinglePerson);
export default __webpack_public_path__ + "static/media/single-person.fd6e1b7f62dc53a62a1f4c43dd147aa0.svg";
export { ForwardRef as ReactComponent };